import * as HttpService from "../services/common-services/HttpService";

export function searchOrganisations(orgSearchParams) {
  return HttpService.getByQuery(
    "api/organisations/search",
    orgSearchParams,
    "IDP"
  );
}
